interface OptionsSettings {
    /** Do not show visual indicator for form fields */
    doNotShadeFormData?: boolean;
    /** Different even/odd page headers and footers */
    evenAndOddHeaders?: boolean;
    /** Do not display visual indication of grammatical errors */
    hideGrammaticalErrors?: boolean;
    /** Do not display visual indication of spelling errors */
    hideSpellingErrors?: boolean;
    /** Automatically recalculate fields on open */
    updateFields?: boolean;
    /** Document view setting */
    view?: "none" | "print" | "outline" | "masterPages" | "normal" | "web";
    /** Magnification setting */
    zoom?: number | ("none" | "fullPage" | "bestFit" | "textFit");
}

/**
 * Create bookmark
 */
class CreateSettings {
    /**
     * Element options
     */
    protected options: OptionsSettings;

    /**
     * Constructor
     *
     * @param options - Options settings
     */
    constructor(options: OptionsSettings) {
        this.options = options;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): Map<string, string> {
        const contents = new Map<string, string>();

        if (this.options.doNotShadeFormData != null) {
            contents.set(
                "w:doNotShadeFormData",
                '<w:doNotShadeFormData w:val="' +
                    this.options.doNotShadeFormData +
                    '"/>'
            );
        }
        if (this.options.evenAndOddHeaders != null) {
            contents.set(
                "w:evenAndOddHeaders",
                '<w:evenAndOddHeaders w:val="' +
                    this.options.evenAndOddHeaders +
                    '"/>'
            );
        }
        if (this.options.hideGrammaticalErrors != null) {
            contents.set(
                "w:hideGrammaticalErrors",
                '<w:hideGrammaticalErrors w:val="' +
                    this.options.hideGrammaticalErrors +
                    '"/>'
            );
        }
        if (this.options.hideSpellingErrors != null) {
            contents.set(
                "w:hideSpellingErrors",
                '<w:hideSpellingErrors w:val="' +
                    this.options.hideSpellingErrors +
                    '"/>'
            );
        }
        if (this.options.updateFields != null) {
            contents.set(
                "w:updateFields",
                '<w:updateFields w:val="' + this.options.updateFields + '"/>'
            );
        }
        if (this.options.view != null) {
            contents.set(
                "w:view",
                '<w:view w:val="' + this.options.view + '"/>'
            );
        }
        if (this.options.zoom != null) {
            if (typeof this.options.zoom === "number") {
                contents.set(
                    "w:zoom",
                    '<w:zoom w:percent="' + this.options.zoom + '"/>'
                );
            } else {
                contents.set(
                    "w:zoom",
                    '<w:zoom w:val="' + this.options.zoom + '"/>'
                );
            }
        }

        return contents;
    }
}

export { CreateSettings, OptionsSettings };
